import React, { useEffect, useRef, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaGlobe, FaUsers, FaComments } from "react-icons/fa";
import CountUp from 'react-countup';

const steps = [
  {
    end: 35,
    suffix: '+ YEARS',
    desc: 'WORLDWIDE EXPERIENCE',
    icon: <FaGlobe className="icon-react" />,
  },
  {
    end: 2000,
    suffix: '+',
    desc: 'SATISFIED CUSTOMERS',
    icon: <FaUsers className="icon-react" />,
  },
  {
    end: 10000,
    suffix: '+ MIL',
    desc: 'Products sold',
    icon: <FaComments className="icon-react" />,
  },
];

const StepsSection = () => {
  const [inView, setInView] = useState(false);
  const sectionRef = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
        }
      },
      { threshold: 0.3 } // adjust as needed
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section className="circle-steps-section" ref={sectionRef}>
      <Container>
        <Row className="justify-content-center">
          {steps.map((step, index) => (
            <Col md={4} key={index} className="step-col mb-5">
              <div className="circle-box">
                <div className="circle">
                  {step.icon}
                </div>
                <div className="label">
                  {inView ? (
                    <CountUp
                      start={0}
                      end={step.end}
                      duration={2}
                      suffix={step.suffix ? ` ${step.suffix}` : ''}
                      className="step-title"
                    />
                  ) : (
                    <span className="step-title">0</span>
                  )}
                </div>
                <p className="description">{step.desc}</p>
                <div className="bottom-circle" />
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default StepsSection;
